import {ApiRequest} from "framework/api";

export function clearUserSettings(){
	return new ApiRequest({
		url: 'userSettings/deleteAll',
		method: 'POST'
	})
}
